const initialState = {
  tipo: null,
  reciboPDF: null,
  data: {
    curt: '',
    superficie_terreno_total: 0.0,
    nombre_contribuyente: '',
    domicilio: '',
    superficie_construccion: 0,
    recibo: {
      folio_forma_valorada: '',
      seguro: 0.0,
      referencia_factura: '',
      fecha: '',
      pk: '',
      importe_redondeado: 0.0,
      total: 0.0,
      subtotal: 0.0,
      salud: 0.0,
      anio: null,
      bimestre: null,
      pagos: [
        {
          gastos: {
            total_ejecucion: 0,
            total_notificacion: 0.0,
            total_multas: 0.0,
          },
          descuentos: {
            total_ejecucion: 0,
            total_recargos: 0.0,
            total_prontopago: 0.0,
            total_notificacion: 0,
            total_especiales: 0,
            total_multas: 0.0,
          },
          valor_catastral: 0.0,
          tasa: 0,
          recargos: {
            total_ej_anterior: 0.0,
            total_corriente: 0.0,
          },
          periodo: {
            anio: 0,
            bimestre_inicial: 0,
            bimestre_final: 0,
          },
          total_actualizacion: 0.0,
          subtotal: 0.0,
          total_impuestos: 0.0,
        },
      ],
    },
    ubicacion: '',
    valor_total_superficie: 0.0,
    valor_total_construccion: 0,
    cuenta_predial: 0,
    superficie_terreno_privada: 0,
    descripcion: '',
    clave_catastral: '',
    tipo_de_predio: '',
    superficie_terreno_comun: 0,
    estado_actual: '',
  },
};

const mutations = {
  SET_DATA(state, payload) {
    state.tipo = payload.tipo;
    state.data = payload.data;
    state.reciboPDF = payload.reciboPDF;
  },
  CLEAR_DATA(state) {
    state.tipo = null;
    state.data = {
      curt: '',
      superficie_terreno_total: 0.0,
      nombre_contribuyente: '',
      domicilio: '',
      superficie_construccion: 0,
      recibo: {
        folio_forma_valorada: '',
        seguro: 0.0,
        referencia_factura: '',
        fecha: '',
        pk: '',
        importe_redondeado: 0.0,
        total: 0.0,
        subtotal: 0.0,
        salud: 0.0,
        pagos: [
          {
            gastos: {
              total_ejecucion: 0,
              total_notificacion: 0.0,
              total_multas: 0.0,
            },
            descuentos: {
              total_ejecucion: 0,
              total_recargos: 0.0,
              total_prontopago: 0.0,
              total_notificacion: 0,
              total_especiales: 0,
              total_multas: 0.0,
            },
            valor_catastral: 0.0,
            tasa: 0,
            recargos: {
              total_ej_anterior: 0.0,
              total_corriente: 0.0,
            },
            periodo: {
              anio: 0,
              bimestre_inicial: 0,
              bimestre_final: 0,
            },
            total_actualizacion: 0.0,
            subtotal: 0.0,
            total_impuestos: 0.0,
          },
        ],
      },
      ubicacion: '',
      valor_total_superficie: 0.0,
      valor_total_construccion: 0,
      cuenta_predial: 0,
      superficie_terreno_privada: 0,
      descripcion: '',
      clave_catastral: '',
      tipo_de_predio: '',
      superficie_terreno_comun: 0,
      estado_actual: '',
    };
    state.reciboPDF = null;
  },
};

const actions = {
  SET_DATA({ commit }, payload) {
    if (typeof payload === 'object') {
      commit('SET_DATA', payload);
    }
  },
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  namespaced: true,
};
